<div class="container">
    <span class="title">{{ title }}</span>
    <!-- a number inputbol -->
    <div class="balance" *ngIf="okText === 'Send Out' && diamondsEnabled">
        <span class="text">Club Balance</span>
        <div class="chip">
            <img class="chip-image" src="/assets/img/chip.svg" />
            <span class="chip-count">{{clubBalance}}</span>
        </div>
    </div>
    <div class="list-wrapper scrollable">
        <ng-container *ngIf="okText === 'Send Out'">
            <ng-container *ngFor="let id of receiverIDs">
                <ng-container *ngIf="sendoutData[id] && isAdmin || sendoutData[id] && sendoutData[myId] && !isAdmin; else skeleton">
                    <div class="element element-sendout">
                        <div class="sender avatar">  
                            <ng-container *ngIf="isAdmin">
                                <div class="avatar-wrapper">
                                    <img [src]="senderImg" (error)="onImageError($event, 'x-small')" class="avatar-img"/>
                                </div>
                                <span>{{ clubName }}</span>
                            </ng-container>
                            <ng-container *ngIf="!isAdmin">
                                <div class="avatar-wrapper">
                                    <img [src]="getAvatarUrl(myId)" class="avatar-img" (error)="onImageError($event, 'x-small', 'avatar')"/>
                                    <img *ngIf="sendoutData[myId] && sendoutData[myId].useNftAsAvatar" src="assets/img/eth_logo.svg" class="eth-logo"/>
                                </div>
                                <span>{{ sendoutData[myId].displayName }}</span>
                            </ng-container>
                            
                        </div>
                        <img class="converter" src="assets/icon/convert.svg"/>
                        <div class="receiver avatar">
                            <div class="avatar-wrapper">
                                <img [src]="getAvatarUrl(id)" class="avatar-img" (error)="onImageError($event, 'x-small', 'avatar')"/>
                                <img *ngIf="sendoutData[id].useNftAsAvatar" src="assets/img/eth_logo.svg" class="eth-logo"/>
                            </div>
                            <span>{{ sendoutData[id].displayName }}</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="okText === 'Claim Back'">
            <ng-container *ngFor="let id of senderIDs">
                <ng-container *ngIf="sendoutData[id] && isAdmin || sendoutData[id] && sendoutData[myId] && !isAdmin; else skeleton">
                    <div class="element element-sendout">
                        <div class="sender avatar">
                            <div class="avatar-wrapper">
                                <img [src]="getAvatarUrl(id)" class="avatar-img" (error)="onImageError($event, 'x-small', 'avatar')"/>
                                <img *ngIf="sendoutData[id].useNftAsAvatar" src="assets/img/eth_logo.svg" class="eth-logo"/>
                            </div>
                            <span>{{ sendoutData[id].displayName }}</span>
                        </div>
                        <img class="converter" src="assets/icon/convert.svg" />
                        <div class="receiver avatar">
                            <ng-container *ngIf="isAdmin">
                                <div class="avatar-wrapper">
                                    <img [src]="receiverID" class="avatar-img" (error)="onImageError($event, 'x-small')"/>
                                </div>
                                <span>{{ clubName }}</span>
                            </ng-container>
                            <ng-container *ngIf="!isAdmin">
                                <div class="avatar-wrapper">
                                    <img [src]="getAvatarUrl(myId)" class="avatar-img" (error)="onImageError($event, 'x-small', 'avatar')"/>
                                    <img *ngIf="sendoutData[myId] && sendoutData[myId].useNftAsAvatar" src="assets/img/eth_logo.svg" class="eth-logo"/>
                                </div>
                                <span>{{ sendoutData[myId].displayName }}</span>
                            </ng-container>
                        </div>
                    </div>
                    <span class="error-text" *ngIf="chipsRoundUp(getMemberBalance(id)) < input">
                        Member has only {{ getMemberBalance(id) }} chips
                    </span>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
    <div class="inputs">
        <input
        #numberInput
        type="number"
        pattern="[0-9]*"
        placeholder="{{ placeholder }}"
        autocomplete="off"
        spellcheck="false"
        [disabled]="isChecked"
        [(ngModel)]="input"
        (ngModelChange)="onModelChange($event)"
        (keyup.enter)="confirm()"
        />
    </div>
    <div class="balance" *ngIf="okText === 'Send Out' && isAdmin">
        <span class="text">Total with 5% service charge</span>
        <div class="chip">
            <img class="chip-image" src="/assets/img/chip.svg" />
            <span class="chip-count">{{serviceTaxChips}}</span>
        </div>
    </div>
    <div class="buttons">
        <span class="submit" (click)="confirm()">{{ okText }}</span>
    </div>
</div>

<ng-template #skeleton>
    <div class="element element-sendout">
        <div class="sender avatar">
            <div class="avatar-wrapper">
                <ion-skeleton-text [animated]="true" class="avatar-skeleton"></ion-skeleton-text>
            </div>
            <span>
                <ion-skeleton-text [animated]="true" class="name-skeleton"></ion-skeleton-text>
            </span>
        </div>
        <img class="converter" src="assets/icon/convert.svg"/>
        <div class="receiver avatar">
            <div class="avatar-wrapper">
                <ion-skeleton-text [animated]="true" class="avatar-skeleton"></ion-skeleton-text>
            </div>
            <span>
                <ion-skeleton-text [animated]="true" class="name-skeleton"></ion-skeleton-text>
            </span>
        </div>
    </div>
</ng-template>
